import { Component, Input } from '@angular/core';
import { EMDMICONS } from '../constants/icon-pack.constant';
import { commonService } from 'src/app/services/common.service';
import { textboxHiddenIcon } from '@progress/kendo-svg-icons';
import { ColumnConfig } from '../models/column-config.model';

@Component({
  selector: 'app-details-popup',
  templateUrl: './details-popup.component.html',
  styleUrl: './details-popup.component.scss'
})
export class DetailsPopupComponent {
  dataList: any[] = [];
  detailsInput: any = null;
  showDetailsPopup: boolean = false;
  popupTitle = '';

  constructor(private commonService: commonService) { }

  popupHeight = 500;

  @Input() set setGridData(data: any) {
    if (data?.length > 0) {
      this.dataList = data;
    }
  }

  @Input() set setDetailsInput(detailsInput: any) {
    if (detailsInput != null) {
      this.detailsInput = detailsInput;
    } else {
      this.detailsInput = null;
    }
  }

  public columnConfig: ColumnConfig[] = [
    //For Example
    // { field: 'type', title: 'Service Type', width: 120 },
    // { field: 'description', title: 'Description', width: 280 },
  ];

  @Input() set setColumnConfig(colList: ColumnConfig[]) {
    if (colList?.length > 0) {
      this.columnConfig = colList;
    }

  }

  iconPacks = EMDMICONS;

  openDetailsPopup() {
    this.showDetailsPopup = true;
  }

  closeDetailsPopup() {
    this.showDetailsPopup = false;
  }
}
